import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyles from 'assets/styles/default.scss';

export const useContainerStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      container: {
        padding: '4px 0',
      },
      button: {
        borderRadius: 4,
        backgroundColor: '#F8F9F7',
      },
    }),
  {
    name: 'SeletorContasContainer',
  }
);

export const useItemStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 0,
        marginBottom: 0,
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column',
          alignItems: 'stretch'
        },
      },
      primary: {
        whiteSpace: 'nowrap', 
        width: '70%',
        overflow: 'hidden',
        textOverflow: 'ellipsis', 
        display: 'block',
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 600,
        height: 32,
        paddingRight: 16,
        borderRight: `1px solid ${sicrediStyles.secondarySicrediLight}`,
        marginRight: 16,
        color: sicrediStyles.secondarySicrediDark,
        [theme.breakpoints.width("sm")]: {
          width: '40%',
        },
        [theme.breakpoints.down('xs')]: {
          width: 'initial',
          display: 'flex',
          borderRight: 'none',
          borderBottom: `1px solid ${sicrediStyles.secondarySicrediLight}`,
          paddingRight: 'initial',
          marginRight: 'initial',
        }
      },
      secondary: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        fontWeight: 400,
        color: '#333333',
        [theme.breakpoints.down('xs')]: {
          display: 'flex',
          alignSelf: 'flex-end'
        }
      },
    }),
  {
    name: 'SeletorContasItem',
  }
);

export const useContaStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      numeroConta: {
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      },
      nomeAssociado: {
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      },
      colaboradorIcon: {
        fontSize: '16px',
        marginRight: '10px',
        color: sicrediStyles.primarySicredi
      }
    }),
  {
    name: 'SeletorContasConta',
  }
);

export const useHeadertyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 0,
        marginBottom: 0,
        width: '100%',
        backgroundColor: '#F8F9F7',
      },
      text: {
        fontFamily: '"Exo 2"',
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 600,
        height: 32,
        color: sicrediStyles.secondarySicrediDarker,
        [theme.breakpoints.down("sm")]: {
          fontSize: 14,
        }
      },
      textPresença: {
        fontFamily: '"Exo 2"',
        alignItems: 'center',
        fontSize: 18,
        fontWeight: 600,
        height: 32,
        color: sicrediStyles.secondarySicrediDarker,
        textAlign: 'center',
        [theme.breakpoints.down("sm")]: {
          fontSize: 14,
        },
      },
      aceite: {
        fontFamily: 'Nunito',
      },
      aceiteText: {
        fontSize: '14px',
        fontWeight: 'normal',
        whiteSpace: 'pre-wrap',
        lineHeight: 1.2,
        margin: '0 0 16px 0',
      },
      legendaText: {
        fontSize: '14px',
        fontWeight: 'bold',
        whiteSpace: 'pre-wrap',
        lineHeight: '20px',
        margin: '10px 0',
        marginRight: '20px',
        '&:last-child': {
          marginRight: '0px',
        }
      },
      legendaIcon: {
        fontSize: '16px',
        marginRight: '10px',
        color: sicrediStyles.primarySicredi,
        verticalAlign: 'text-bottom',
      },
      switchAceiteRow: {
        flexWrap: 'wrap',
        flexDirection: 'row',
        display: 'flex',
        borderTop: `1px solid #CDD3CD`,
        borderBottom: `1px solid #CDD3CD`,
        alignItems: 'center',
        boxSizing: 'border-box',
      },
      switchAceite: {
        '& .MuiFormControlLabel-label': {
          fontFamily: 'Nunito',
          fontSize: '12px',
        },
      }
    }),
  {
    name: 'SeletorContasItem',
  }
);
